import React from 'react'
import { ScrollView, Text, View } from 'react-native'
import { useDispatch, useSelector } from 'react-redux';
import { useCssStyle } from '../../customHook/getCssStyle';
import { useTranslation } from 'react-i18next';
import { setRenderFlashMessage } from '../../Redux/Actions/appConfigAction';
import HeaderWithBack from '../../components/Header/headerWithBack';
import { isFirstReservation } from '../../Redux/Actions/reservationAction';
import { CustomTextInput } from '../../components/customTextInput';
import CustomPressable from '../../components/customPressable/customPressable';
import { ImageComp } from '../../components/Image/Image';
import { getCleanUrl } from '../../utils/Helper';

const ReservationsAdditionalInfo = (props) => {
    const { myReservations, additionalInfo, setAdditionalInfo, handleNext, handleGoBack } = props;

    const { t } = useTranslation();
    const getStyles = useCssStyle();
    const dispatch = useDispatch();

    const { currentWidget } = useSelector(state => state.deviceConfigSlice);


    const handleGoNext = () => {
        let emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        if (isFirstReservation()) {
            if (additionalInfo.firstName == "") {
                dispatch(setRenderFlashMessage(true, {type: "danger", message: t("events.enter_firstName")}))
                return;
            }
        }
        if (isFirstReservation()) {
            if (additionalInfo.lastName == "") {
                dispatch(setRenderFlashMessage(true, {type: "danger", message: t("events.enter_lastName")}))
                return;
            }
        }
        if (isFirstReservation() || myReservations[0].phone_number=='') {
            if (additionalInfo.phoneNumber == "" ) {
                dispatch(setRenderFlashMessage(true, {type: "danger", message: t("events.enter_phoneNumber")}))
                return;
            }
        }

        if (isFirstReservation()) {
            if (additionalInfo.email == "") {
                dispatch(setRenderFlashMessage(true, {type: "danger", message: t("events.enter_email")}))
                return;
            }
            if (!emailRegex.test(additionalInfo.email)) {
                // popupOpenClose(true, "Please enter a valid email");
                dispatch(setRenderFlashMessage(true, {type: "danger", message: "Please enter a valid email"}))
                return;
            }
        }




        handleNext();
    }


    const renderHeader = () => {
        return <View style={getStyles(['widgetmainContainerHeaderContainer', 'reservationsHeaderContainer'])}>
        {
            currentWidget?.widgetHeaderImageUrl &&
            <ImageComp source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'reservationsHeaderImg'])} />
        }
        <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'reservationsHeaderTitleContainer'])}>
            <Text style={getStyles(['widgetmainContainerHeaderTitle', 'reservationsHeaderTitle'])}>{t('events.heading6')}</Text>
        </View>
        </View>
    }
    return (
        <View style={getStyles(['widgetRootContainer', 'reservationsRootContainer'])}>
            <HeaderWithBack handleCustomBackPress={handleGoBack} />
                                    
            <ScrollView
                automaticallyAdjustKeyboardInsets={true} 
                contentContainerStyle={getStyles(['widgetmainContainer', 'reservationsMainContainer'])} 
                showsVerticalScrollIndicator={false}
            >
                {renderHeader()}

                <View style={getStyles(['widgetmainContainerChildContainer', 'reservationsMainContainerChildContainer', {gap: 16, marginTop: 16}])}>

                    {isFirstReservation() &&
                        <View style={getStyles(['textContainer'])}>
                            <Text style={getStyles(['label'])}>{t("events.firstName")} <Text style={{ color: "red" }}>*</Text></Text>
                            <CustomTextInput
                                value={additionalInfo.firstName}
                                onChangeText={(value) => setAdditionalInfo({ ...props.additionalInfo, firstName: value })} 
                                placeholder={t('events.firstName_placeholder')}
                            />
                        </View>
                        }


                    {isFirstReservation() &&
                        <View style={getStyles(['textContainer'])}>
                            <Text style={getStyles(['label'])}>{t("events.lastName")} <Text style={{ color: "red" }}>*</Text></Text>
                            <CustomTextInput
                                value={additionalInfo.guestCount}
                                onChangeText={(value) => setAdditionalInfo({ ...props.additionalInfo, lastName: value })}
                                placeholder={t('events.lastName_placeholder')}
                                // placeholder={resp.placeholder}
                            />
                        </View>
                        }

                        
                    <View style={getStyles(['textContainer'])}>
                        <Text style={getStyles(['label'])}>{t("events.email")} <Text style={{ color: "red" }}>*</Text></Text>
                        <CustomTextInput
                            disabled={!(isFirstReservation())}
                            value={isFirstReservation() ? additionalInfo.email : myReservations?.[0]?.email || ''}
                            onChangeText={(value) => setAdditionalInfo({ ...props.additionalInfo, email: value })} 
                            placeholder={t('events.email_placeholder')}
                        />
                    </View>



                    {(isFirstReservation() || myReservations?.[0]?.phone_number ==' ') &&

                    <View style={getStyles(['textContainer'])}>
                        <Text style={getStyles(['label'])}>{t("events.phone_number")} <Text style={{ color: "red" }}>*</Text></Text>
                        <CustomTextInput
                            disabled={!(isFirstReservation())}
                            value={additionalInfo?.phoneNumber}
                            onChangeText={(value) => setAdditionalInfo({ ...props.additionalInfo, phoneNumber: value })} 
                            placeholder={t('events.phoneNumber_placeholder')}
                        />
                    </View>
                    }




                    <View style={getStyles(['textContainer'])}>
                        <Text style={getStyles(['label'])}>{t("events.guestComment")} </Text>
                        <CustomTextInput
                            style={{ height: 100 }}
                            disabled={!(isFirstReservation())}
                            value={additionalInfo?.guestComment}
                            onChangeText={(value) => setAdditionalInfo({ ...props.additionalInfo, guestComment: value })} 
                            placeholder={t('events.guestComment_placeholder')}
                            multiline
                            numberOfLines={3}
                        />
                    </View>

                </View>
                
            </ScrollView>

            <View id='reservationsNextButtonContainer' style={getStyles(['reservationsNextButtonContainer'])}>
                <CustomPressable style={getStyles(["primaryBtn"])} onPress={()=> handleGoNext()} id="primaryBtn">
                    <Text style={getStyles(["primaryBtnTxt"])} id='primaryBtnTxt'>
                        {t("events.continue")}
                    </Text>
                </CustomPressable>

                {/* <CustomPressable style={getStyles(["secondaryBtn"])} onPress={()=> handleGoBack()} id="secondaryBtn">
                    <Text style={getStyles(["secondaryBtnTxt"])} id='secondaryBtnTxt'>
                        {t("events.back")}
                    </Text>
                </CustomPressable> */}
            </View>
        </View>
    )
}

export default ReservationsAdditionalInfo
